// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"a351cef6","724":"8909f57c","787":"e74d9ce3","914":"ad25a775"}[chunkId] + ".chunk.js";
};